import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Heart, Share2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LIKED_KEY = "dzt_liked";

const getLiked = () => {
  try { return JSON.parse(localStorage.getItem(LIKED_KEY) || "[]"); } catch { return []; }
};
const setLikedStore = (arr) => localStorage.setItem(LIKED_KEY, JSON.stringify(arr));

export const StoryActions = ({ id, likes = 0, size = "sm" }) => {
  const [liked, setLiked] = useState(() => getLiked().includes(id));
  const [count, setCount] = useState(likes);
  const [busy, setBusy] = useState(false);

  const iconSize = size === "lg" ? 22 : 18;
  const padY = size === "lg" ? "py-3" : "py-2";

  const toggleLike = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (busy) return;
    const next = !liked;
    setLiked(next);
    setCount((c) => Math.max(0, c + (next ? 1 : -1)));
    const arr = getLiked();
    setLikedStore(next ? [...new Set([...arr, id])] : arr.filter((x) => x !== id));
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/tori/${id}/like`, { liked: next });
      if (typeof data.likes === "number") setCount(data.likes);
    } catch {
      // Revert optimistic update on failure
      setLiked(!next);
      setCount((c) => Math.max(0, c + (next ? -1 : 1)));
      const cur = getLiked();
      setLikedStore(!next ? [...new Set([...cur, id])] : cur.filter((x) => x !== id));
      toast.error("Kon je like niet opslaan. Probeer opnieuw.");
    } finally {
      setBusy(false);
    }
  };

  const share = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const url = `${window.location.origin}/verhalen/${id}`;
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link gekopieerd naar klembord!");
    } catch {
      // Fallback
      const ta = document.createElement("textarea");
      ta.value = url;
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand("copy"); toast.success("Link gekopieerd!"); }
      catch { toast.error("Kopiëren mislukt."); }
      ta.remove();
    }
  };

  return (
    <div className="flex items-center gap-3">
      <button
        onClick={toggleLike}
        data-testid={`like-${id}`}
        aria-pressed={liked}
        className={`flex items-center gap-2 px-4 ${padY} rounded-full border-2 font-[700] transition-colors ${
          liked ? "bg-[#B71C1C] border-[#B71C1C] text-white" : "bg-white border-[#B71C1C] text-[#B71C1C] hover:bg-[#FEF9E7]"
        }`}
      >
        <Heart size={iconSize} className={liked ? "fill-white" : ""} />
        <span data-testid={`like-count-${id}`}>{count}</span>
      </button>
      <button
        onClick={share}
        data-testid={`share-${id}`}
        className={`flex items-center gap-2 px-4 ${padY} rounded-full border-2 border-[#1B6B2E] text-[#1B6B2E] font-[700] bg-white hover:bg-[#E8F5E9] transition-colors`}
      >
        <Share2 size={iconSize} /> Deel
      </button>
    </div>
  );
};
